import { type App } from 'vue';

import { link, titleClamp } from './directives';
import { setupChartjs } from './chartjs';
import { setupDayjs } from './dayjs';
import { setupI18n } from './i18n';
import { type SharedPluginOptions } from './sharedPluginOptions';
import { setupVuetify } from './vuetify';

export { i18n } from './i18n';
export { type SharedPluginOptions } from './sharedPluginOptions';

export function registerSharedPlugins(app: App, options?: Partial<SharedPluginOptions>): void {
	app.use(setupChartjs()).use(setupDayjs()).use(setupI18n(options)).use(setupVuetify(options));
	app.directive('link', link);
	app.directive('title-clamp', titleClamp);
};